// import { Badge } from "../../../../../components/ui/badge_v2"
// import { Card } from "../../../../../components/ui/card"
// import { Building2, Grid3x3, Shield, Package, FileText } from "lucide-react"

// // Mock data for display
// const SCHOOLS = [
//   { id: "school-1", name: "Lincoln High School" },
//   { id: "school-2", name: "Washington Academy" },
// ]

// const MODULES = [
//   { id: "mod-1", name: "English Literature" },
//   { id: "mod-2", name: "Mathematics" },
//   { id: "mod-3", name: "Science" },
//   { id: "mod-4", name: "History" },
//   { id: "mod-5", name: "Art & Design" },
//   { id: "mod-6", name: "Physical Education" },
// ]

// const PROMPT_CATEGORIES = [
//   { id: "cat-1", name: "Creative Writing" },
//   { id: "cat-2", name: "Academic Research" },
//   { id: "cat-3", name: "Professional Communication" },
// ]

// const PROMPTS = [
//   { id: "prompt-1", name: "Character Development" },
//   { id: "prompt-2", name: "Plot Generation" },
//   { id: "prompt-3", name: "Dialogue Writing" },
//   { id: "prompt-4", name: "Literature Review" },
//   { id: "prompt-5", name: "Thesis Development" },
//   { id: "prompt-6", name: "Citation Help" },
//   { id: "prompt-7", name: "Email Drafting" },
//   { id: "prompt-8", name: "Report Writing" },
//   { id: "prompt-9", name: "Presentation Copy" },
// ]

// const POLICIES = [
//   { id: "policy-1", name: "Content View" },
//   { id: "policy-2", name: "Content Edit" },
//   { id: "policy-3", name: "Content Delete" },
//   { id: "policy-4", name: "Admin Access" },
// ]

// export function ReviewStep({ rights }) {
//   const getItemName = (id, collection) => {
//     return collection.find((item) => item.id === id)?.name || id
//   }

//   return (
//     <div className="space-y-6">
//       <div>
//         <h3 className="text-lg font-semibold text-foreground mb-2">Review Permissions</h3>
//         <p className="text-sm text-muted-foreground mb-6">Please review the permissions before saving</p>
//       </div>

//       {/* Schools */}
//       {rights.schools_id.length > 0 && (
//         <Card className="p-4 border border-border bg-background">
//           <div className="flex items-center gap-2 mb-4">
//             <Building2 className="w-5 h-5 text-primary" />
//             <h4 className="font-semibold text-foreground">Schools</h4>
//           </div>
//           <div className="flex flex-wrap gap-2">
//             {rights.schools_id.map((schoolId) => (
//               <Badge key={schoolId} variant="outline" className="bg-primary/10 text-primary border border-primary/20">
//                 {getItemName(schoolId, SCHOOLS)}
//               </Badge>
//             ))}
//           </div>
//         </Card>
//       )}

//       {/* Modules */}
//       {rights.module_ids.length > 0 && (
//         <Card className="p-4 border border-border bg-background">
//           <div className="flex items-center gap-2 mb-4">
//             <Package className="w-5 h-5 text-primary" />
//             <h4 className="font-semibold text-foreground">Modules ({rights.module_ids.length})</h4>
//           </div>
//           <div className="flex flex-wrap gap-2">
//             {rights.module_ids.map((moduleId) => (
//               <Badge key={moduleId} variant="outline" className="border-border">
//                 {getItemName(moduleId, MODULES)}
//               </Badge>
//             ))}
//           </div>
//         </Card>
//       )}

//       {/* Prompt Categories */}
//       {rights.prompt_category_ids.length > 0 && (
//         <Card className="p-4 border border-border bg-background">
//           <div className="flex items-center gap-2 mb-4">
//             <Grid3x3 className="w-5 h-5 text-primary" />
//             <h4 className="font-semibold text-foreground">Prompt Categories ({rights.prompt_category_ids.length})</h4>
//           </div>
//           <div className="flex flex-wrap gap-2">
//             {rights.prompt_category_ids.map((catId) => (
//               <Badge key={catId} variant="outline" className="bg-primary/10 text-primary border border-primary/20">
//                 {getItemName(catId, PROMPT_CATEGORIES)}
//               </Badge>
//             ))}
//           </div>
//         </Card>
//       )}

//       {/* Prompts */}
//       {rights.prompt_ids.length > 0 && (
//         <Card className="p-4 border border-border bg-background">
//           <div className="flex items-center gap-2 mb-4">
//             <FileText className="w-5 h-5 text-primary" />
//             <h4 className="font-semibold text-foreground">Prompts ({rights.prompt_ids.length})</h4>
//           </div>
//           <div className="flex flex-wrap gap-2">
//             {rights.prompt_ids.map((promptId) => (
//               <Badge key={promptId} variant="outline" className="border-border">
//                 {getItemName(promptId, PROMPTS)}
//               </Badge>
//             ))}
//           </div>
//         </Card>
//       )}

//       {/* Policies */}
//       {rights.policies_id.length > 0 && (
//         <Card className="p-4 border border-border bg-background">
//           <div className="flex items-center gap-2 mb-4">
//             <Shield className="w-5 h-5 text-primary" />
//             <h4 className="font-semibold text-foreground">Policies ({rights.policies_id.length})</h4>
//           </div>
//           <div className="flex flex-wrap gap-2">
//             {rights.policies_id.map((policyId) => (
//               <Badge
//                 key={policyId}
//                 variant="outline"
//                 className="bg-green-600/10 text-green-700 border border-green-600/20"
//               >
//                 {getItemName(policyId, POLICIES)}
//               </Badge>
//             ))}
//           </div>
//         </Card>
//       )}

//       {/* Empty State */}
//       {Object.values(rights).every((arr) => arr.length === 0) && (
//         <Card className="p-8 border border-dashed border-muted bg-muted/30 text-center">
//           <p className="text-muted-foreground">No permissions selected yet</p>
//         </Card>
//       )}
//     </div>
//   )
// }



import { Badge } from "../../../../../components/ui/badge_v2"
import { Card } from "../../../../../components/ui/card"
import { Building2, Grid3x3, Shield, Package, FileText } from "lucide-react"


import { useSchoolsStore } from "../../../../../context/useSchoolsStore"
import { useModulesStore } from "../../../../../context/useModulesStore"
import { usePromptCategoriesStore } from "../../../../../context/usePromptCategoriesStore" 
import { usePromptsStore } from "../../../../../context/usePromptsStore"
import useLanguage from "../../../../../services/useLanguage";



export function ReviewStep({ rights }) {
  const { schools } = useSchoolsStore()
  const { modules } = useModulesStore()
  const { promptCategories } = usePromptCategoriesStore()
  const { prompts } = usePromptsStore()
  const currentLang = useLanguage();

  const getItemName = (id, collection) => {
    switch(collection){
      case "SCHOOLS":
        return schools.find((item) => item.id === id)?.name || id
      case "MODULES":
        return modules.find((item) => item.id === id)?.name || id
      case "PROMPT_CATEGORIES":
        return promptCategories.find((item) => item.id === id)?.title[currentLang] || id
      case "PROMPTS":
        return prompts.find((item) => item.id === id)?.title[currentLang] || id
    }
  }

  const renderCRUDOperations = (operations,collection) => {
    return Object.entries(operations).map(([op, ids]) => (
      <div key={op} className="flex flex-wrap gap-2">
        <span className="text-xs font-semibold text-muted-foreground bg-muted px-2 py-1 rounded">
          {op.toUpperCase()}
        </span>
        <div className="flex flex-wrap gap-2 flex-1">
          {ids.length > 0 ? (
            ids.map((id) => (
              <Badge key={id} variant="outline" className="bg-primary/10 text-primary border border-primary/20">
                {getItemName(id, collection)}
              </Badge>
            ))
          ) : (
            <span className="text-xs text-muted-foreground italic">None</span>
          )}
        </div>
      </div>
    ))
  }

  const hasAnyRights =
    rights.schools.create.length > 0 ||
    rights.modules.create.length > 0 ||
    rights.prompt_categories.create.length > 0 ||
    rights.prompts.create.length > 0 ||
    rights.policies.create.length > 0

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-2">Review Permissions</h3>
        <p className="text-sm text-muted-foreground mb-6">Please review the permissions before saving</p>
      </div>

      {/* Schools */}
      <Card className="p-4 border border-border bg-background">
        <div className="flex items-center gap-2 mb-4">
          <Building2 className="w-5 h-5 text-primary" />
          <h4 className="font-semibold text-foreground">Schools</h4>
        </div>
        <div className="space-y-3">{renderCRUDOperations(rights.schools,"SCHOOLS")}</div>
      </Card>

      {/* Modules */}
      <Card className="p-4 border border-border bg-background">
        <div className="flex items-center gap-2 mb-4">
          <Package className="w-5 h-5 text-primary" />
          <h4 className="font-semibold text-foreground">Modules</h4>
        </div>
        <div className="space-y-3">{renderCRUDOperations(rights.modules,"MODULES")}</div>
      </Card>

      {/* Prompt Categories */}
      <Card className="p-4 border border-border bg-background">
        <div className="flex items-center gap-2 mb-4">
          <Grid3x3 className="w-5 h-5 text-primary" />
          <h4 className="font-semibold text-foreground">Prompt Categories</h4>
        </div>
        <div className="space-y-3">{renderCRUDOperations(rights.prompt_categories,"PROMPT_CATEGORIES")}</div>
      </Card>

      {/* Prompts */}
      <Card className="p-4 border border-border bg-background">
        <div className="flex items-center gap-2 mb-4">
          <FileText className="w-5 h-5 text-primary" />
          <h4 className="font-semibold text-foreground">Prompts</h4>
        </div>
        <div className="space-y-3">{renderCRUDOperations(rights.prompts,"PROMPTS")}</div>
      </Card>

      {/* Policies */}
      {/* <Card className="p-4 border border-border bg-background">
        <div className="flex items-center gap-2 mb-4">
          <Shield className="w-5 h-5 text-primary" />
          <h4 className="font-semibold text-foreground">Policies</h4>
        </div>
        <div className="space-y-3">{renderCRUDOperations(rights.policies,"POLICIES")}</div>
      </Card> */}

      {/* Empty State */}
      {!hasAnyRights && (
        <Card className="p-8 border border-dashed border-muted bg-muted/30 text-center">
          <p className="text-muted-foreground">No permissions selected yet</p>
        </Card>
      )}
    </div>
  )
}
